export default __webpack_public_path__ + "static/media/NeueHaasUnicaW02-Regular.7b7530f3.ttf";